import React from "react"
import { ADD } from "../../include/constant"
import VoucherForm from "../common/VoucherForm"
import SuperAdminHeader from "./Header"

const SuperAdminAddVoucher = () => {
    return <SuperAdminHeader >
         <div className="fixed-top-bar">
        <VoucherForm
            title="Add Voucher"
            type={ADD}
        />
     </div>
    </SuperAdminHeader>
}

export default SuperAdminAddVoucher